import HeidiTogetherBoxesRebrand from '@/assets/image/free-to-pay/heidi-together-boxes-svg/heidi-together-boxes-rebrand.svg';
import Image, { type ImageProps } from 'next/image';

export const HeidiTogetherBoxesSvg = (props: Omit<ImageProps, 'src'>) => {
  const { alt = 'heidi together boxes', ...rest } = props;

  return <Image src={HeidiTogetherBoxesRebrand} alt={alt} {...rest} />;
};
